import React from 'react'
import * as S from './Icon.styles'
import Glyphs from './glyphs'

interface IconProps {
  name: string;
  ariaLabel?: string;
  size?: 'small' | 'medium' | 'large';
  useIconColor?: boolean;
  'aria-hidden'?: boolean;
  color?: string;
  round?: boolean;
  unlockedProportions?: boolean;
}

const Icon = ({ name, ariaLabel = name.replace(/-/g, ' '), ...props }: IconProps) => {
  const SvgIcon = Glyphs[name as keyof typeof Glyphs]

  if (!SvgIcon) {
    console.error(`Icon ${name} not found`)
    return null
  }

  return (
    <S.Icon {...props} aria-label={ariaLabel}>
      <SvgIcon />
    </S.Icon>
  )
}

export default Icon
